import { z } from "zod";

export const GetTxStatus$Params = z.object({
  txId: z.string(),
});
export type GetTxStatus$Params = z.infer<typeof GetTxStatus$Params>;

export const GetTxStatus$Result = z.object({
  ok: z.boolean(),
  gachaMinting: z
    .union([
      z.object({
        type: z.literal("fulfilled"),
        txId: z.string(),
        artworkIds: z.string().array(),
      }),
      z.object({
        type: z.literal("refunded"),
        txId: z.string(),
      }),
    ])
    .nullish(),
});
export type GetTxStatus$Result = z.infer<typeof GetTxStatus$Result>;
